<template>
    <!--页面 -->
    <section>

        <div style="text-align: center;margin-top: 100px;font-size: 30px;">无操作权限
         <div>{{count}}秒后返回</div>
        </div>


    </section>
</template>
<script>

export default {
    data() {
      return{
        count:"",
        timer:null,
      }
    },
    methods: {
      threeGo(){
      		const TIME_COUNT = 3;
      		if(!this.timer){
      			this.count = TIME_COUNT;
      			this.show = false;
      			this.timer = setInterval(()=>{
      			if(this.count > 0 && this.count <= TIME_COUNT){
      				this.count--;
      			}else{
      				this.show = true;
      				clearInterval(this.timer);
      				this.timer = null;
      				//返回前一页
      				this.$router.back(-1);
      			}
      		  },1000)
      		}
          },


    },
    created() {
        this.threeGo();
    },
    activated() {

    }

}
</script>



// WEBPACK FOOTER //
// src/view/showNoAuth.vue